"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Version = require("./Version");
Object.keys(_Version).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Version[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Version[key];
    }
  });
});